module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-item"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteEventItem(_vm.item.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "is-one-quarter column"
  }, [_c('el-time-picker', {
    attrs: {
      "format": "HH:mm",
      "picker-options": {
        start: '00:00',
        step: '00:10',
        end: '23:59'
      },
      "placeholder": "00:00"
    },
    on: {
      "change": _vm.timeChanged
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-half column"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  })], 1), _vm._v(" "), (!_vm.item.speakers.length) ? _c('div', [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleAddSpeaker
    }
  }, [_vm._v("Добавить спикера")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "link add-subtitle",
    on: {
      "click": _vm.handleAddSubtitle
    }
  }, [_vm._v("Добавить подзаголовок")])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.item.speakers) ? _c('div', {
    staticClass: "speakers"
  }, _vm._l((_vm.item.speakers), function(speaker, ind) {
    return _c('EventItemSpeaker', {
      key: speaker.id,
      attrs: {
        "index": ind,
        "speaker": speaker
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-offset-one-quarter"
  }, [(_vm.item.speakers.length) ? _c('div', {
    staticClass: "addition-buttons"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleAddSpeaker
    }
  }, [_vm._v("Добавить спикера")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "link add-subtitle",
    on: {
      "click": _vm.handleAddSubtitle
    }
  }, [_vm._v("Добавить подзаголовок")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c9f5f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EventItem.vue
// module id = 903
// module chunks = 0